import ProductPage from './ProductPage.container';

export default ProductPage;